import { render } from "./AuthError.vue?vue&type=template&id=0d61ba83&scoped=true&ts=true"
import script from "./AuthError.vue?vue&type=script&lang=ts"
export * from "./AuthError.vue?vue&type=script&lang=ts"

import "./AuthError.vue?vue&type=style&index=0&id=0d61ba83&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d61ba83"]])

export default __exports__